import { createAuthClient } from 'better-auth/react';

/** Client Better Auth : même origine que l'application (Vite relaie /api/auth vers l'API). */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/api/auth',
});

export const { useSession, signIn, signUp, signOut } = authClient;
